

module.exports = __webpack_require__.stylable.create(
    "Caption2665372808",
    {"classes":{"root":"Caption2665372808__root","c1":"Caption2665372808__c1"},"vars":{},"stVars":{},"keyframes":{}},
    ".Caption2665372808__c1,.Caption2665372808__root.Text4076772322---size-6-medium.Text4076772322---weight-4-bold.Caption2665372808---caption-2-c1{font-size:10px;line-height:12px}",
    5,
    "Caption2665372808",
    __webpack_require__.stylable.$
);
